export default __webpack_public_path__ + "static/media/i_bus-jeonse_gn_tagless.69c2aaa1.svg";